import React from 'react'

export default function FaceFeature({ scaleX, fill }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M9.49005 2.78003C10.7001 4.29003 11.48 6.63001 11.48 9.26001C11.48 13.82 9.14005 17.52 6.24005 17.52C3.34005 17.52 1 13.82 1 9.26001C1 4.70001 3.34005 1 6.24005 1"
        stroke={fill} // "#FFDC2E"
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M67.3 2.78003C66.09 4.29003 65.3101 6.63001 65.3101 9.26001C65.3101 13.82 67.65 17.52 70.55 17.52C73.44 17.52 75.79 13.82 75.79 9.26001C75.79 4.70001 73.45 1 70.55 1"
        stroke={fill} // "#FFDC2E"
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
  )
}
